import { useEffect, useState } from 'react'
import { crmClient } from './client'
import type { CrmPermissions } from './crmRail'

const cache = new Map<string, CrmPermissions>()

/**
 * This login's CRM page permissions on one account (the CRM's GET
 * /v1/permissions, the snapshot its own page-access.js reads). Null while
 * loading or when the CRM refuses; the last answer per account is reused.
 */
export function useCrmPermissions(accountId: string | undefined): CrmPermissions | null {
  const [perms, setPerms] = useState<CrmPermissions | null>(() => (accountId ? cache.get(accountId) ?? null : null))

  useEffect(() => {
    if (!accountId) return
    setPerms(cache.get(accountId) ?? null)
    let live = true
    crmClient
      .get(accountId, `/v1/permissions?account_id=${encodeURIComponent(accountId)}`)
      .then(async (res) => {
        if (!res.ok) return null
        const body = (await res.json()) as CrmPermissions & { data?: CrmPermissions }
        return body.data ?? body
      })
      .catch(() => null)
      .then((next) => {
        if (!live || !next) return
        cache.set(accountId, next)
        setPerms(next)
      })
    return () => {
      live = false
    }
  }, [accountId])

  return perms
}
